module.exports = __webpack_public_path__ + "img/group-light.24472a63.png";